import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";

const ContactInformation = (props) => {
  const { contactInformation } = props;
  return (
    <>
      <div className="form-group">
        <Row>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.prezime.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "contactInformation" }}
              value={contactInformation.prezime}
              id="prezime"
              name="prezime"
              controlLabel={"Prezime"}
            />
          </Col>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.ime.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "contactInformation" }}
              value={contactInformation.ime}
              id="ime"
              name="ime"
              controlLabel={"Ime"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.telefon.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "contactInformation" }}
              value={contactInformation.telefon}
              id="telefon"
              name="telefon"
              controlLabel={"Broj telefona"}
            />
          </Col>
          <Col>
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.web.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "contactInformation" }}
              value={contactInformation.web}
              id="web"
              name="web"
              controlLabel={"Adresa internetske stranice"}
            />
          </Col>
        </Row>
        <Row>
          <ColDynamic className="col-lg-8 input-style">
            <InputComponent
              required={props.required}
              style={
                props.required &&
                props.parentState.error &&
                contactInformation.email.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "contactInformation" }}
              value={contactInformation.email}
              id="email"
              name="email"
              controlLabel={"Email"}
            />
            {
              //validacija na email
              !contactInformation.emailValidated &&
                contactInformation.email.length > 0 &&
                props.parentState.error && (
                  <p style={{ color: "red" }}>
                    E-mail koji ste upisali nije ispravan!
                  </p>
                )
            }
          </ColDynamic>
        </Row>
      </div>
    </>
  );
};

export default ContactInformation;
